// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"da1ce2c4","132":"a1d21a14","243":"4f3f076a","438":"2da9f94e","488":"0bffb5bf","508":"d0961705","553":"71ac039a","861":"d5e1ebce","942":"319e34b6"}[chunkId] + ".chunk.js";
};